import type { PropsWithChildren } from "react";

import { StyledManagementCardButton } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";
import type { RequestAdminFeature } from "app/pages/sales-intelligence/types/requestAdminFeature";

import IntegrationButtonWrapper from "./IntegrationButtonWrapper";

interface IProps {
    dataAutomation: string;
    featureName: RequestAdminFeature;
    mainButtonType: "outlined" | "primary";
    hasAccess?: boolean;
    isEnabled?: boolean;
    onUpgradeClick: VoidFunction;
    onRequestAccess?: VoidFunction;
    onManageClick: VoidFunction;
}

const IntegrationButton = ({
    mainButtonType,
    onManageClick,
    dataAutomation,
    children,
    ...props
}: PropsWithChildren<IProps>): React.ReactElement => {
    return (
        <IntegrationButtonWrapper
            dataAutomationNameSpace={dataAutomation}
            {...props}
        >
            <StyledManagementCardButton
                buttonHtmlType="button"
                type={mainButtonType}
                onClick={onManageClick}
                data-automation={`${dataAutomation}.integration-card-manage-button`}
            >
                {children}
            </StyledManagementCardButton>
        </IntegrationButtonWrapper>
    );
};

export default IntegrationButton;
